import { useState } from "react";
import { Button } from "../../../components/ui/button";
import { Modal, ModalBody, ModalHeader } from "../../../components/ui/Modal";
import { predefinedComments } from "./predefinedComments";

export interface CommentEditModalProps {
  isOpen: boolean;
  initialComment: string;
  onClose: () => void;
  onSave: (comment: string) => Promise<void>;
  title?: string;
}

export const CommentEditModal = ({
  isOpen,
  initialComment,
  onClose,
  onSave,
  title = "Edytuj komentarz",
}: CommentEditModalProps) => {
  const [comment, setComment] = useState(initialComment);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave(comment);
      onClose();
    } catch (error) {
      console.error("Failed to save comment:", error);
    } finally {
      setSaving(false);
    }
  };

  const handleClose = () => {
    if (!saving) {
      setComment(initialComment); // Reset on cancel
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <ModalHeader title={title} onClose={handleClose} />
      <ModalBody>
        <label className="block">
          <span className="mb-1 block text-xs font-medium text-[var(--sc-muted)] uppercase tracking-[0.05em]">Komentarz</span>
          <select
            className="mb-2 w-full rounded-lg border border-[var(--sc-border)] bg-[var(--sc-bg)] px-3 py-2 text-sm text-[var(--sc-text)] focus:outline-none focus:ring-1 focus:ring-[var(--sc-amber)]"
            value=""
            disabled={saving}
            onChange={e => {
              if (e.target.value) setComment(e.target.value);
            }}
          >
            <option value="">Wybierz predefiniowany komentarz...</option>
            {predefinedComments.map((c, idx) => (
              <option key={idx} value={c}>{c}</option>
            ))}
          </select>
          <textarea
            className="w-full rounded-lg border border-[var(--sc-border)] px-3 py-2 text-sm text-[var(--sc-text)] placeholder:text-[var(--sc-muted)] focus:outline-none focus:ring-1 focus:ring-[var(--sc-amber)] whitespace-pre-wrap"
            placeholder="Wprowadź komentarz..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows={6}
            maxLength={8000}
            disabled={saving}
          />
        </label>

        <div className="flex justify-end gap-2 pt-2">
          <Button onClick={handleClose} variant="secondary" disabled={saving}>
            Anuluj
          </Button>
          <Button onClick={handleSave} disabled={saving}>
            {saving ? "Zapisywanie..." : "Zapisz"}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};